import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Plus, Trash2, ExternalLink, Globe } from 'lucide-react';
interface CompetitorLinksModalProps {
  isOpen: boolean;
  onClose: () => void;
  product: any;
}
export function CompetitorLinksModal({
  isOpen,
  onClose,
  product
}: CompetitorLinksModalProps) {
  if (!isOpen) return null;
  const [links, setLinks] = useState([{
    id: 1,
    name: 'Amazon',
    url: 'https://amazon.com.br/dp/B09V3HN1KC',
    active: true
  }, {
    id: 2,
    name: 'Magalu',
    url: 'https://magazineluiza.com.br/p/2345678',
    active: true
  }, {
    id: 3,
    name: 'Kabum',
    url: 'https://kabum.com.br/produto/123456',
    active: false
  }]);
  const [newUrl, setNewUrl] = useState('');
  const [newName, setNewName] = useState('');
  const handleAdd = () => {
    if (newUrl && newName) {
      setLinks([...links, {
        id: Date.now(),
        name: newName,
        url: newUrl,
        active: true
      }]);
      setNewUrl('');
      setNewName('');
    }
  };
  const handleDelete = (id: number) => {
    setLinks(links.filter(l => l.id !== id));
  };
  return <AnimatePresence data-id="element-24">
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-25">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" data-id="element-26" />

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden" data-id="element-27">
          <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100" data-id="element-28">
            <h2 className="text-lg font-bold text-navy-900" data-id="element-29">
              Links de Concorrentes
            </h2>
            <button onClick={onClose} className="text-slate-400 hover:text-navy-900 transition-colors" data-id="element-30">
              <X className="h-5 w-5" data-id="element-31" />
            </button>
          </div>

          <div className="p-6" data-id="element-32">
            <p className="text-sm text-slate-500 mb-4" data-id="element-33">
              Gerencie os links monitorados para{' '}
              <span className="font-medium text-navy-900" data-id="element-34">{product?.name}</span>
              . O sistema fará a varredura automática nestas URLs.
            </p>

            <div className="space-y-3 mb-6 max-h-[300px] overflow-y-auto" data-id="element-35">
              {links.map(link => <div key={link.id} className="flex items-center justify-between p-3 bg-slate-50 border border-slate-100 rounded-lg group hover:border-navy-200 transition-colors" data-id="element-36">
                  <div className="flex items-center space-x-3 overflow-hidden" data-id="element-37">
                    <div className="h-8 w-8 rounded-full bg-white border border-slate-200 flex items-center justify-center text-xs font-bold text-navy-900 shadow-sm flex-shrink-0" data-id="element-38">
                      {link.name.charAt(0)}
                    </div>
                    <div className="min-w-0" data-id="element-39">
                      <p className="text-sm font-medium text-navy-900 truncate" data-id="element-40">
                        {link.name}
                      </p>
                      <a href={link.url} target="_blank" rel="noreferrer" className="text-xs text-blue-500 hover:underline truncate block max-w-[200px] flex items-center" data-id="element-41">
                        {link.url}{' '}
                        <ExternalLink className="h-3 w-3 ml-1 inline" data-id="element-42" />
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-43">
                    <button onClick={() => handleDelete(link.id)} className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors" data-id="element-44">
                      <Trash2 className="h-4 w-4" data-id="element-45" />
                    </button>
                  </div>
                </div>)}
            </div>

            <div className="bg-slate-50 p-4 rounded-xl border border-slate-200" data-id="element-46">
              <h4 className="text-sm font-semibold text-navy-900 mb-3" data-id="element-47">
                Adicionar Novo Link
              </h4>
              <div className="space-y-3" data-id="element-48">
                <input type="text" placeholder="Nome do Concorrente (ex: Amazon)" value={newName} onChange={e => setNewName(e.target.value)} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-900" data-id="element-49" />
                <div className="flex gap-2" data-id="element-50">
                  <div className="relative flex-1" data-id="element-51">
                    <Globe className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" data-id="element-52" />
                    <input type="url" placeholder="https://..." value={newUrl} onChange={e => setNewUrl(e.target.value)} className="w-full pl-9 pr-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-900" data-id="element-53" />
                  </div>
                  <button onClick={handleAdd} disabled={!newUrl || !newName} className="px-4 py-2 bg-navy-900 text-white rounded-lg text-sm font-medium hover:bg-navy-800 disabled:opacity-50 transition-colors flex items-center" data-id="element-54">
                    <Plus className="h-4 w-4 mr-1" data-id="element-55" />
                    Adicionar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>;
}